import { jsx } from "panel";
import { RowFilters } from "common/query-builder/query-entry-section/components/filters";
import { RowSelector } from "common/query-builder/query-entry-section/components/selector";
import { EntryPart } from "common/query-builder/query-entry-section/types";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { Placement } from "common/components/tooltip/types";
import { BaseEntryRowEl } from "../base/template";
import { NumberOfStepsSubitem } from "./components/number-of-steps-subitem";
export function FlowsEntryRowEl({ section, entry, index }) {
  const selectorIcon = entry.funnelStep ? `funnel-steps` : null;
  const selectorRenderer = () => /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(RowSelector, {
    el: section,
    entry,
    index,
    isPlaceholder: !this.hasEventValue(),
    selectorIcon
  }));
  const suffixRenderer = () => {
    var _a, _b;
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".mp-query-entry-row.for-flows-steps"
    }, /* @__PURE__ */ jsx(NumberOfStepsSubitem, {
      forward: (_a = entry.forward) != null ? _a : 0,
      reverse: (_b = entry.reverse) != null ? _b : 0,
      menuChangeHandler: this.handleStepsMenuChange.bind(this),
      updateStepsValueHandler: this.handleStepsUpdate.bind(this)
    })), /* @__PURE__ */ jsx(RowFilters, {
      el: section,
      entry,
      event: entry.event,
      index,
      handleUpdate: (filters, filtersOperator, queryReason) => this.handleFilterSectionUpdate(filters, filtersOperator, queryReason)
    }));
  };
  const actionsRenderer = section.getRowFilteringCapabilities(this).canApplyFilter && (() => /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Tertiary,
      icon: `filter-xs`,
      tooltip: {
        "delay-in": 10,
        "delay-out": 10,
        placement: Placement.Top,
        text: `Filter`
      }
    },
    on: {
      click: () => section.helpers.showPlaceholderForEntry(EntryPart.Filters, index)
    }
  })));
  return /* @__PURE__ */ jsx(BaseEntryRowEl, {
    index,
    el: section,
    entry,
    rowRenderer: {
      actionsRenderer,
      selectorRenderer,
      suffixRenderer
    },
    isPlaceholder: this.isPlaceholder()
  });
}
